'use strict';

var bemReactClassname = require('bem-react-classname');

var _a;
var withTheme = (_a = bemReactClassname.createTheme('alfa-on-white'), _a.withTheme), ThemeProvider = _a.ThemeProvider;
var getCoreTheme = function (theme) { return (theme === 'alfa-on-color' ? 'inverted' : 'default'); };

exports.ThemeProvider = ThemeProvider;
exports.getCoreTheme = getCoreTheme;
exports.withTheme = withTheme;
